import {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {signOutUser} from './userSlice';
import {H1} from '../../components/ui/Header';
import {useHistory} from 'react-router-dom';
import {messageAdded} from '../messages/messagesSlice';

export default function UserSignOut() {
  const dispatch = useDispatch()
  const history = useHistory()
  const status = useSelector(state => state.user.status)

  useEffect(() => {
    dispatch(signOutUser())
    dispatch(messageAdded('Signed Out'))
  }, [dispatch])
  
  if(status.signOut === 'pending') {
    return <H1>Signing out...</H1>
  }

  if(status.signOut === 'fulfilled') {
    return <H1>Signed out!</H1>
  }

  history.push('/')
  return null
}